import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { ApplicationMenu } from './applicationMenu.js';

var _excluded = ["submenu", "label"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var BaseMenuItem = /*#__PURE__*/_createClass(function BaseMenuItem() {
  _classCallCheck(this, BaseMenuItem);
  _defineProperty(this, "id", void 0);
  _defineProperty(this, "click", void 0);
  _defineProperty(this, "enabled", void 0);
  _defineProperty(this, "visible", void 0);
  _defineProperty(this, "htmlProps", void 0);
  _defineProperty(this, "icon", void 0);
  _defineProperty(this, "description", void 0);
  _defineProperty(this, "before", void 0);
  _defineProperty(this, "after", void 0);
});
var SubmenuMenuItem = /*#__PURE__*/function (_BaseMenuItem) {
  _inherits(SubmenuMenuItem, _BaseMenuItem);
  var _super = _createSuper(SubmenuMenuItem);
  function SubmenuMenuItem(_ref) {
    var _this;
    var submenu = _ref.submenu,
      label = _ref.label,
      restOptions = _objectWithoutProperties(_ref, _excluded);
    _classCallCheck(this, SubmenuMenuItem);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "type", 'submenu');
    _defineProperty(_assertThisInitialized(_this), "submenu", void 0);
    _defineProperty(_assertThisInitialized(_this), "label", void 0);
    _this.label = label;
    if (Array.isArray(submenu)) {
      _this.submenu = ApplicationMenu.buildFromTemplate(submenu);
    } else {
      _this.submenu = new ApplicationMenu();
    }
    Object.assign(_assertThisInitialized(_this), restOptions);
    return _this;
  }
  return _createClass(SubmenuMenuItem);
}(BaseMenuItem);
var isSubmenuMenuItem = function isSubmenuMenuItem(item) {
  return item.type === 'submenu';
};

export { SubmenuMenuItem, isSubmenuMenuItem };
